import { DEPUTY_ENUM } from './deputy';

interface OrganizationImages {
  id: string;
  en: string;
}

export const getOrgStructureImage = (id = '') => {
  const organizationImages: Record<string, OrganizationImages> = {
    [DEPUTY_ENUM.SECRETARIAT]: {
      id: require('../assets/organization/id/sekutama.png'),
      en: require('../assets/organization/en/sekutama.png'),
    },
    [DEPUTY_ENUM.INSPECTORATE]: {
      id: require('../assets/organization/id/insputama.png'),
      en: require('../assets/organization/en/insputama.png'),
    },
    [DEPUTY_ENUM.REHAB]: {
      id: require('../assets/organization/id/rehab.png'),
      en: require('../assets/organization/en/rehab.png'),
    },
    [DEPUTY_ENUM.LABORATORY]: {
      id: require('../assets/organization/id/lab.png'),
      en: require('../assets/organization/en/lab.png'),
    },
    [DEPUTY_ENUM.ERADICATION]: {
      id: require('../assets/organization/id/eradication.png'),
      en: require('../assets/organization/en/eradication.png'),
    },
    [DEPUTY_ENUM.LEGAL]: {
      id: require('../assets/organization/id/legal.png'),
      en: require('../assets/organization/en/legal.png'),
    },
    [DEPUTY_ENUM.PREVENTION]: {
      id: require('../assets/organization/id/prevention.png'),
      en: require('../assets/organization/en/prevention.png'),
    },
    [DEPUTY_ENUM.PUBLIC]: {
      id: require('../assets/organization/id/public.png'),
      en: require('../assets/organization/en/public.png'),
    },
    [DEPUTY_ENUM.HRD]: {
      id: require('../assets/organization/id/hrd.png'),
      en: require('../assets/organization/en/hrd.png'),
    },
    [DEPUTY_ENUM.RESEARCH]: {
      id: require('../assets/organization/id/puslitdatin.png'),
      en: require('../assets/organization/en/puslitdatin.png'),
    },
  };

  return organizationImages[id];
};

export const getBackgroundImage = (id = '') => {
  switch (id) {
    case DEPUTY_ENUM.SECRETARIAT:
      return require('../assets/main/bg-sec-utama.jpg');
    case DEPUTY_ENUM.INSPECTORATE:
      return require('../assets/main/bg-inspek-utama.jpg');
    case DEPUTY_ENUM.REHAB:
      return require('../assets/main/bg-rehab.png');
    case DEPUTY_ENUM.LABORATORY:
      return require('../assets/main/bg-puslabnarkotika.jpg');
    case DEPUTY_ENUM.ERADICATION:
      return require('../assets/main/bg-pemberantas.jpg');
    case DEPUTY_ENUM.LEGAL:
      return require('../assets/main/bg-deputi-hukum-kerjasama.jpg');
    case DEPUTY_ENUM.PREVENTION:
      return require('../assets/main/bg-prevention.jpg');
    case DEPUTY_ENUM.PUBLIC:
      return require('../assets/main/bg-deputi-pemberdayaan-masyarakat.jpg');
    case DEPUTY_ENUM.HRD:
      return require('../assets/main/bg-ppsdm.jpg');
    case DEPUTY_ENUM.RESEARCH:
      return require('../assets/main/bg-research.jpg');
    default:
      return '';
  }
};
